export const GRID_STYLE_VARS = {
  headerBackgroundColor: "rgb(249 250 251)",
  headerForegroundColor: "rgb(75 85 99)",
  rowHoverColor: "rgb(249 250 251)",
  borderColor: "rgb(229 231 235)",
  cellHorizontalPadding: "12px",
  fontFamily: '"InterVariable", "Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
  fontSize: "14px",
  lineHeight: "1.5",
} as const;

export const GRID_DIMENSIONS = {
  defaultRowHeight: 48,
  defaultHeaderHeight: 40,
  defaultMinColumnWidth: 100,
} as const;

export const GRID_DEFAULTS = {
  undoRedoLimit: 20,
  rowBuffer: 25,
  emptyStateMessage: "No rows to show",
} as const;
